import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=79f6cb68&scoped=true&"
var script = {}
import style0 from "./Resume.vue?vue&type=style&index=0&id=79f6cb68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f6cb68",
  null
  
)

export default component.exports